import NotFound from "./notFound.js";
export default NotFound;